if (!customElements.get("m-gmaps")) {
    class MGmaps extends HTMLElement {
        constructor() {
            super();
            this.mapElm = this.querySelector("#m-gmaps-inner");
            this.mapTitle = this.mapElm.dataset.mapTitle;
            this.mapAddress = this.mapElm.dataset.mapAddress || "";
            this.mapZoom = this.mapElm.dataset.mapZoom;
            this.mapX = this.mapElm.dataset.mapX;
            this.mapY = this.mapElm.dataset.mapY;
            this.key = this.mapElm.dataset.key;
            if (!this.mapElm.dataset.key) {
                return;
            }
        }

        connectedCallback() {
            this.prepMapApi();
        }

        prepMapApi() {
            this.loadScript().then(this.initMap.bind(this));
        }

        loadScript() {
            return new Promise((resolve, reject) => {
                const script = document.createElement("script");
                document.body.appendChild(script);
                script.onload = resolve;
                script.onerror = reject;
                script.async = true;
                script.src = "https://maps.googleapis.com/maps/api/js?key=" + this.mapElm.dataset.key;
            });
        }

        createMap(center) {
            const mapOptions = {
                zoom: parseInt(this.mapZoom),
                center: center,
                draggable: true,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: false,

            };
            const map = new google.maps.Map(this.mapElm, mapOptions);
            new google.maps.Marker({
                map: map,
                position: center,
                title: this.mapTitle,
            });

            google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(map, "resize");
            });
        }

        initMap() {
            // If address is provided, use geocoding
            if (this.mapAddress && this.mapAddress.trim() !== "") {
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address: this.mapAddress }, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK && results[0]) {
                        const location = results[0].geometry.location;
                        this.createMap(location);
                    } else {
                        // Fallback to coordinates if geocoding fails
                        console.warn("Geocoding failed, falling back to coordinates:", status);
                        this.createMapFromCoords();
                    }
                });
            } else {
                // Use coordinates directly
                this.createMapFromCoords();
            }
        }

        createMapFromCoords() {
            if (this.mapX && this.mapY) {
                const center = new google.maps.LatLng(parseFloat(this.mapX), parseFloat(this.mapY));
                this.createMap(center);
            } else {
                console.error("No address or coordinates provided for map");
            }
        }
    }

    customElements.define("m-gmaps", MGmaps);
}
